import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const usePharmacyStore = create(
	persist(
		(set) => ({
			pharmacyLocations: [],
			selectedPharmacy: null,
			token: null,
			ecosystem: null,
			platform: null,
			locations: [],
			isNewFile: {
				isNewFile: null,
				id: null,
			},
			setPharmacyLocations: (newPharmacy) => set({ pharmacyLocations: newPharmacy }),
			setSelectedPharmacy: (pharmacy) => set({ selectedPharmacy: pharmacy }),
			setLocations: (newLocations) => set({ locations: newLocations }),
			setIsNewFile: (enable) => set({ isNewFile: enable }),
			setPlatform: (platform) => set({ platform: platform }),
			setEcosystem: (ecosystem) => set({ ecosystem: ecosystem }),
			setToken: (token) => set({ token: token }),
		}),
		{
			name: 'pharmacy-storage',
			getStorage: () => sessionStorage,
		},
	),
);

export default usePharmacyStore;
